import PropTypes from "prop-types";
import React from "react";
import { Minus, Plus } from "react-feather";

const QuantityConfigurator = ({ increment, decrement, quantity }) => {
    return (
        <div
            className={`quantity-configurator ${
                quantity <= 0 || !quantity ? "disabled" : ""
            }`}
        >
            <div className="remove-button" onClick={decrement}>
                <Minus />
            </div>
            <div className="count"> {quantity} </div>
            <div className="add-button" onClick={increment}>
                <Plus />
            </div>
        </div>
    );
};

QuantityConfigurator.propTypes = {
    increment: PropTypes.func,
    decrement: PropTypes.func,
    quantity: PropTypes.number,
};

export default QuantityConfigurator;
